export default __webpack_public_path__ + "static/media/box.610d3919.jpg";